import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getIsDateWithinXDays } from '@wix/da-i18next/pkg/time/functions';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import CoreBadge, { CorePackage } from '@wix/da-ds/pkg/Badges/CoreBadge';
import { CoreLevel } from '@wix/da-react-context/pkg/publicSession';

import s from './CoreMenuItem.scss';

interface Props {
  className?: string;
  hasCoreMembership?: boolean;
  coreLevel?: CoreLevel;
  coreExpires?: string;
}

const CoreMenuItem: React.FC<Props> = ({
  className,
  hasCoreMembership,
  coreLevel,
  coreExpires,
}) => {
  const { t } = useTranslation();

  const isUpgradableCoreLevel =
    coreLevel === 'core_access' || coreLevel === 'core_plus';
  const coreExpiresIn30 = coreExpires && getIsDateWithinXDays(coreExpires, 30);
  const upgradableAndExpiringCore = isUpgradableCoreLevel && coreExpiresIn30;
  const showUpgradeIndicator = !hasCoreMembership || upgradableAndExpiringCore;

  return (
    <div
      className={classnames(
        s['root'],
        className,
        hasCoreMembership && coreLevel && s[`package-${coreLevel}`]
      )}
    >
      {showUpgradeIndicator ? (
        <CoreUpgradeIndicator
          className={classnames(hasCoreMembership && s['ds-override'])}
        >
          {t(
            hasCoreMembership
              ? 'siteHeader.userMenu.coreMenuItem.upgradeCore'
              : 'siteHeader.userMenu.coreMenuItem.getCore'
          )}
        </CoreUpgradeIndicator>
      ) : (
        <>
          <span>
            {hasCoreMembership && coreLevel
              ? t(`siteHeader.userMenu.coreLabel.${coreLevel}`)
              : t('siteHeader.userMenu.buyCoreMembership')}
          </span>
          <span>
            {!hasCoreMembership && (
              <CoreBadge
                corePackage={coreLevel as CorePackage}
                className={s['core-icon']}
                size="large"
              />
            )}
          </span>
        </>
      )}
    </div>
  );
};
CoreMenuItem.displayName = 'CoreMenuItem';

export default CoreMenuItem;
